import { CurrencyPipe, DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'positiveToBracket',
    standalone: false
})
export class PositiveToBracket implements PipeTransform {
  constructor(private numberPipe: DecimalPipe) {}
  transform(value: any): any {
    let val = Number(value)
    if(!val)
      return value;
    else{
      if(val>0)
        return ('('+ this.numberPipe.transform( val.toString()) )+')';
      else
        return this.numberPipe.transform(val.toString().substring(1, val.toString().length));
    }
  }
}
